import sliceCreator from '../../index.jsx';
import {UPDATE_PRE_SEASON_ACTIVITY} from '../../../constants/index.jsx';
const _updatePreSeasonActivityAction = sliceCreator('UPDATE_PRE_SEASON_ACTIVITY', UPDATE_PRE_SEASON_ACTIVITY, 'put');

const { asyncAction: updatePreSeasonActivityAction, reducer, clearData: clearUpdatePreSeasonActivityAction } = _updatePreSeasonActivityAction;

export default reducer;

export {
    updatePreSeasonActivityAction,
    clearUpdatePreSeasonActivityAction
}